import React from "react";
import { OneRow } from "../../core/layouts";
import DashboardContainer from "../../containers/DasboardContainer";
import variables from "../../themes/base/styles/variables";
import useResponsive from "../../core/hooks/useResponsive";

export const DashboardViewStyles = {
  oneRowStyle: {
    overflow: variables.unset,
    width:variables.fullWidth
  },
};

const DashboardView = () => {
  const responsive = useResponsive();
  return (
    <OneRow
      style={responsive.isMd ? DashboardViewStyles.oneRowStyle : {}}
      section={<DashboardContainer />}
    />
  );
};

export default DashboardView;
